var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.56292 1.28674C7.75342 0.943837 8.24658 0.943837 8.43708 1.28674L10.373 4.77133C10.4525 4.91457 10.5972 5.00972 10.7603 5.02603L14.4501 5.39501C14.8698 5.43698 15.0522 5.94782 14.7539 6.24608L11.6892 9.31078C11.571 9.429 11.5197 9.59847 11.5525 9.7624L12.2842 13.421C12.3684 13.842 11.9178 14.1663 11.5453 13.9529L8.24862 12.0635C8.09462 11.9753 7.90538 11.9753 7.75138 12.0635L4.45471 13.9529C4.08221 14.1663 3.6316 13.842 3.7158 13.421L4.44752 9.7624C4.48031 9.59847 4.429 9.429 4.31078 9.31078L1.24608 6.24608C0.947816 5.94782 1.13017 5.43698 1.54989 5.39501L5.23971 5.02603C5.40275 5.00972 5.54746 4.91457 5.62704 4.77133L7.56292 1.28674Z",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.e3f827337cfc00fd0461b8c18b72ad31.svg";
export { ForwardRef as ReactComponent };